import { useQuery } from "@tanstack/react-query";
import { adminGetAllUnits } from "../queries";
import { ContentContext } from "../../../contexts/contextExporter";
import ItemUnit from "./ItemUnit";
import PracticeLoader from "../../practice/PracticeLoader";
import { usePickedTreeFromUrl } from "./usePickedTreeFromUrl";
import { useState } from "react";
import clsx from "clsx";
import AddPracticeController from "./AddPracticeController";
import PartSummary from "./PartSummary";

export default function ContentContextProvider() {
  const [pickedTree, setPickedTree] = usePickedTreeFromUrl();
  const { data: allUnits } = useQuery(adminGetAllUnits());
  const [mode, setMode] = useState<"view" | "add">("view");

  return (
    <ContentContext.Provider value={{ pickedTree, setPickedTree }}>
      <div className="flex flex-col h-screen w-full">
        <div></div>
        <div className="flex-1 flex overflow-hidden">
          {/*  */}
          <div className="border-r panel h-full flex flex-col overflow-hidden p-4 pt-3 pr-0 w-96">
            <div className="flex justify-between gap-2 pb-2 pr-4 items-center border-b border-white/15">
              <div className="text-myOrange text-xl font-bold">All Units</div>
              <button className="bg-myOrange/30 font-semibold hover:text-myOrange transition-colors cursor-pointer rounded-lg px-3 py-1.5 ">
                Yeni ekle
              </button>
            </div>
            <div className="flex-1 overflow-auto pr-2">
              {allUnits?.map((unit) => <ItemUnit key={unit.id} unit={unit} />)}
            </div>
          </div>
          {/*  */}
          <div className="flex flex-col h-full overflow-hidden flex-1">
            <div className="panel border-b flex">
              <div
                className={clsx(
                  "p-4 border-r border-white/15",
                  mode === "view" ? "text-myOrange font-semibold" : "cursor-pointer"
                )}
                onClick={() => setMode("view")}
              >
                Listele
              </div>
              <div
                className={clsx(
                  "p-4 border-r border-white/15",
                  mode === "add" ? "text-myOrange font-semibold" : "cursor-pointer"
                )}
                onClick={() => setMode("add")}
              >
                Ekle
              </div>
            </div>
            {pickedTree.partId && mode === "view" && (
              <div className="flex-1 overflow-hidden">
                <div className="h-full w-full flex flex-col">
                  <PartSummary mlId={pickedTree.mlId!} partId={pickedTree.partId} />
                  <div className="flex-1 overflow-auto">
                    <PracticeLoader partId={pickedTree.partId} />
                  </div>
                </div>
              </div>
            )}

            {pickedTree.partId && mode === "add" && (
              <AddPracticeController />
            )}
          </div>
        </div>
      </div>
    </ContentContext.Provider>
  );
}
